/**
 * Supported language codes for the application
 */
export const LANGUAGE_KEY = "language";
export const SUPPORTED_LANGUAGES = ["en", "es"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * Utility function to get the language parameter from the URL query string
 * Only returns the language if it's a supported locale, otherwise returns undefined
 * @returns The validated language code (e.g., "es", "en") or undefined if not present/invalid
 */
export const getLanguage = (checkSession: boolean = true): string | undefined => {
  const params = new URLSearchParams(window.location.search);
  const languageParam = params.get(LANGUAGE_KEY) || (checkSession ? sessionStorage.getItem(LANGUAGE_KEY) : undefined);

  // Validate against supported languages
  if (languageParam && SUPPORTED_LANGUAGES.includes(languageParam as SupportedLanguage)) {
    return languageParam;
  }

  return undefined;
};

export const setLanguage = (language: string | undefined) => {
  if (language && SUPPORTED_LANGUAGES.includes(language as SupportedLanguage)) {
    sessionStorage.setItem(LANGUAGE_KEY, language);
  } else {
    sessionStorage.removeItem(LANGUAGE_KEY);
  }
};
